import React, { useState } from 'react'
import { getMUICache, getImageId, getImageUrl, getImageSize, getImageCreditString } from "../../../common/utils"
import { CacheProvider } from '@emotion/react';
import PhotoShowTwoAmpStyles from './PhotoShowTwoAmp.css'
import { Grid, Typography, Button } from '@mui/material';
import React from 'react';
import React from 'react';
import React from 'react';

const Slide = (props) => {
    const cache = getMUICache();
    const { item, maxlength, currentIndex, showNewsAgency, isViewport} = props;
    const {showImageCredits, slideShowParentData, containerEndpoint} = props;
    const { id } = item;
    return (
        
                <div>
                    <div className="themeTwotopAmpWrap">
                      
                         <div className='ampThemeTwoShortdis'> <div className='ampThemeTwoCounter'> <span className='ampTwoCurrentOndex'>{currentIndex}</span> / {maxlength}</div> {item.hl}</div>
                    </div>
                    <div className="ampTwoPhotoWrapper">
                        {getImageSize(item.imageid) && <img width="330" height="247" alt={(item?.metaInfo?.Alttitle ? item.metaInfo.Alttitle : item?.hl)?.slice(0, 25)} title={item?.hl?.slice(0, 25)} src={getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 330, undefined, item.pubInfo.baseDomain, false,  props.CONSTANTS)} />}
                        
                    </div>

                    <div className='ampCommonImagecreditMainWrapper themeTwoAmpCommonImagecreditMainWrapper'>
                        {showImageCredits && item && getImageSize(item.imageid) && <div className='ampCommonImageCeditAgencyAuth'>{getImageCreditString(item.ag, item.au, item.metaInfo?.ImageCreditSourceName, item.pubInfo?.channel)}</div>}
                  </div>
                    
                    <div className="ampThemeTwoPhotoDis">{item.syn}</div>
                </div>

           
    )
}

export default Slide;